import * as React from 'react';
import styled from 'styled-components'
import {mixinBtnSmall, mixinResetBtnCss, mixinBtnBorder, mixinWithBtnPropsFn, IBtnDefaultProps} from "./btn_mixin";

interface IProps
    extends IBtnDefaultProps, React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
}

const BtnBorderSmallDefault: React.FC<IProps> = (props) => {

    const { icon, widthSize, ...ButtonProps } = props;

    return (<button {...ButtonProps} />)

};

const BtnBorderSmall = styled(BtnBorderSmallDefault)`
    ${mixinResetBtnCss}
    ${mixinBtnSmall}
    ${mixinBtnBorder}
    
    ${props => mixinWithBtnPropsFn(props)}
`;

export default BtnBorderSmall;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_border_small.tsx